import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types: MarketTypes, Creators: MarketActions } = createActions(
  {
    fetchMarketSuggestedExperiences: ['market'],
    fetchMarketsExperiencesTotal: [],
    setCurrentMarketBySlug: ['slug'],
    setCurrentMarketId: ['id'],
    setMarketSuggestedExperiences: ['market', 'experiences'],
    setMarketExperiencesTotal: ['total'],
  },
  { prefix: 'MARKET_' }
);

export const INITIAL_STATE = Immutable({
  currentMarketId: null,
  suggestedMarketExperiences: {},
  marketExperiencesTotal: {},
});

const setCurrentMarketId = (state, { id }) => state.set('currentMarketId', id);

const handleSetMarketSuggestedExperiences = (state, { market, experiences }) =>
  state.setIn(['suggestedMarketExperiences', market], Immutable(experiences));

const setMarketExperiencesTotal = (state, { total }) =>
  state.update('marketExperiencesTotal', data => data.merge(Immutable(total)));

export const reducer = createReducer(INITIAL_STATE, {
  [MarketTypes.SET_CURRENT_MARKET_ID]: setCurrentMarketId,
  [MarketTypes.SET_MARKET_SUGGESTED_EXPERIENCES]: handleSetMarketSuggestedExperiences,
  [MarketTypes.SET_MARKET_EXPERIENCES_TOTAL]: setMarketExperiencesTotal,
});
